export enum TagColorEnum {
  OWN = '#7ab9ff',
  WISHLIST = '#ffae4a',
  READING = '#d59aed',
  READ = '#89da8e',
  LIKE = '#f97e60',
}
